// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Oj-z","tupacHeader":"Pj-z","tupacHeader2":"Qj-z","tupacMenu":"Rj-z","tupacMenu2":"Sj-z","tupacMain":"Tj-z","tupacMain2":"Uj-z"};